export const useNumAnimation = (option: {
  from: number;
  to: number;
  duration: number;
  easing?: (t: number) => number;
  onUpdate?: (value: number) => void;
}) => {
  const { from, to, duration, easing = (t) => t } = option;
  // const speed = (to - from) / duration; // 每秒增加的速度
  //let value = from; // 当前值
  const startTime = Date.now(); // 开始时间
  let animationFrameId: number | null = null;

  const run = () => {
    const elapsed = Date.now() - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const easedProgress = easing(progress);
    const value = (from + (to - from) * easedProgress).toFixed(0);
    option.onUpdate?.(value);
    if (progress < 1) {
      animationFrameId = requestAnimationFrame(run);
    } else {
      option.onUpdate?.(value); // 确保最终值精确
      if (animationFrameId !== null) {
        cancelAnimationFrame(animationFrameId);
      }
    }
    // animationFrameId = requestAnimationFrame(run); // 继续动画循环
  };
  return run;
};
